<cm-color-picker
    [attr.data-label]="label"
    [attr.data-color]="hex"
    [attr.data-alpha]="alpha"
    [attr.data-hide-alpha]="hideAlpha ? true : null"
    (change)="onColorChange($event.detail)">
    @if (lowContrast) {
        <cm-tooltip [attr.data-tooltip-text]="'Color_Picker.Error.Low_Contrast' | trans">
            <span aria-hidden="true" class="cm-icon cm-icon-information contrast-warning cl-error-icon-color"></span>
        </cm-tooltip>
    }
</cm-color-picker>
